import {
  isZapOrcaProActive,
  getZapOrcaProPayload,
  ativarLicencaPro,
  desativarLicencaPro,
} from './pro';
import { generatePixPayload } from '../pix';
import { renderQrSvg } from '../qr';

export interface ProModalOptions {
  abaInicial?: 'pix' | 'chave';
  onAtivado?: () => void;
  onDesativado?: () => void;
}

const CONFIG_PIX_ZAPORCA_PRO = {
  chavePix: 'codjeremias@gmail.com',
  nomeRecebedor: 'JEREMIAS CARDOSO',
  cidadeRecebedor: 'BRASILIA',
  valor: 29.90,
  txId: 'ZAPORCAPRO',
  descricao: 'Passaporte ZapOrca Pro Anual',
};

/**
 * Abre o modal de aquisição e ativação do Passaporte ZapOrca Pro.
 */
export function openZapOrcaProModal(options: ProModalOptions = {}): void {
  const existing = document.getElementById('modal-zaporca-pro');
  if (existing) existing.remove();

  const proAtivo = isZapOrcaProActive();
  let abaAtiva: 'pix' | 'chave' = options.abaInicial || (proAtivo ? 'chave' : 'pix');

  const modal = document.createElement('div');
  modal.id = 'modal-zaporca-pro';
  modal.className = 'z-dialog-backdrop fixed inset-0 z-50 flex items-center justify-center p-4 bg-slate-950/75 backdrop-blur-sm';

  const pixResult = generatePixPayload(CONFIG_PIX_ZAPORCA_PRO);
  const qrCodeSvg = renderQrSvg(pixResult.brCode, { width: 180, margin: 1 });

  function renderConteudo(): void {
    const isPro = isZapOrcaProActive();
    const payload = getZapOrcaProPayload();

    if (isPro && payload) {
      const dataExp = payload.exp === -1 ? 'Permanente (Vitalícia)' : new Date(payload.exp * 1000).toLocaleDateString('pt-BR');
      const planoNome = payload.plano === 'vitalicio' ? 'Vitalício Permanente' : 'Assinatura Anual';

      modal.innerHTML = `
        <div class="z-dialog max-w-md w-full bg-white dark:bg-neutral-900 rounded-3xl shadow-2xl border border-amber-300 dark:border-amber-700/50 overflow-hidden relative" style="margin: auto;">
          <div class="p-6 bg-gradient-to-br from-amber-500/15 via-emerald-500/10 to-transparent border-b border-neutral-200 dark:border-neutral-800 flex items-center justify-between">
            <div class="flex items-center gap-3">
              <div class="w-12 h-12 rounded-2xl bg-amber-500/20 border border-amber-500/30 flex items-center justify-center text-2xl shadow-inner">
                ✨
              </div>
              <div>
                <h3 class="text-base font-extrabold text-neutral-900 dark:text-white flex items-center gap-1.5">
                  <span>ZapOrca Pro Ativo</span>
                  <span class="text-[10px] uppercase tracking-wider bg-amber-100 dark:bg-amber-950/60 text-amber-800 dark:text-amber-300 px-2 py-0.5 rounded-full font-bold">Oficial</span>
                </h3>
                <p class="text-xs text-neutral-500 dark:text-neutral-400">Plano ${planoNome}</p>
              </div>
            </div>
            <button type="button" id="btn-fechar-pro" class="w-8 h-8 rounded-full bg-neutral-100 dark:bg-neutral-800 text-neutral-500 hover:text-neutral-900 flex items-center justify-center font-bold text-lg">
              ✕
            </button>
          </div>

          <div class="p-6 space-y-4">
            <div class="bg-neutral-50 dark:bg-neutral-800/60 rounded-2xl p-4 border border-neutral-200 dark:border-neutral-700 text-xs space-y-2">
              <div class="flex justify-between">
                <span class="text-neutral-500">Titular Licenciado:</span>
                <strong class="text-neutral-900 dark:text-white font-mono">${payload.sub}</strong>
              </div>
              ${payload.nome ? `
                <div class="flex justify-between">
                  <span class="text-neutral-500">Razão / Nome:</span>
                  <strong class="text-neutral-900 dark:text-white">${payload.nome}</strong>
                </div>
              ` : ''}
              <div class="flex justify-between">
                <span class="text-neutral-500">Validade:</span>
                <strong class="text-emerald-600 dark:text-emerald-400">${dataExp}</strong>
              </div>
              <div class="flex justify-between">
                <span class="text-neutral-500">Orçamentos:</span>
                <strong class="text-emerald-600 dark:text-emerald-400">Ilimitados</strong>
              </div>
              <div class="flex justify-between">
                <span class="text-neutral-500">Marca d'água no PDF:</span>
                <strong class="text-emerald-600 dark:text-emerald-400">Removida (White-label)</strong>
              </div>
              <div class="flex justify-between">
                <span class="text-neutral-500">Exportação em Planilha:</span>
                <strong class="text-emerald-600 dark:text-emerald-400">Liberada (CSV/Excel)</strong>
              </div>
              <div class="flex justify-between">
                <span class="text-neutral-500">Criptografia:</span>
                <strong class="text-neutral-600 dark:text-neutral-300">ECDSA P-256 (Local)</strong>
              </div>
            </div>

            <div class="pt-2 flex gap-3">
              <button type="button" id="btn-desativar-pro" class="btn-touch btn-secondary flex-1 py-3 text-xs font-bold text-red-600 hover:text-red-700 border-red-200 dark:border-red-900/40">
                Desativar neste Aparelho
              </button>
              <button type="button" id="btn-ok-pro" class="btn-touch btn-primary flex-1 py-3 text-xs font-bold shadow-md">
                Fechar
              </button>
            </div>
          </div>
        </div>
      `;

      modal.querySelector('#btn-fechar-pro')?.addEventListener('click', () => modal.remove());
      modal.querySelector('#btn-ok-pro')?.addEventListener('click', () => modal.remove());
      modal.querySelector('#btn-desativar-pro')?.addEventListener('click', () => {
        if (confirm('Tem certeza de que deseja desativar a licença Pro deste dispositivo? Você voltará ao plano gratuito.')) {
          desativarLicencaPro();
          options.onDesativado?.();
          renderConteudo();
        }
      });
      return;
    }

    // Caso NÃO seja Pro: exibe abas de Compra Pix e Inserir Chave
    modal.innerHTML = `
      <div class="z-dialog max-w-lg w-full bg-white dark:bg-neutral-900 rounded-3xl shadow-2xl border border-neutral-200 dark:border-neutral-800 overflow-hidden relative" style="margin: auto;">
        <!-- Header -->
        <div class="p-5 bg-gradient-to-r from-amber-500/10 via-emerald-500/10 to-transparent border-b border-neutral-200 dark:border-neutral-800 flex items-center justify-between">
          <div class="flex items-center gap-3">
            <div class="w-10 h-10 rounded-2xl bg-amber-500/20 border border-amber-500/30 flex items-center justify-center text-xl shadow-inner">
              ✨
            </div>
            <div>
              <h3 class="text-base font-extrabold text-neutral-900 dark:text-white">Passaporte ZapOrca Pro</h3>
              <p class="text-xs text-neutral-500 dark:text-neutral-400">Propostas ilimitadas e PDF oficial para MEIs</p>
            </div>
          </div>
          <button type="button" id="btn-fechar-pro" class="w-8 h-8 rounded-full bg-neutral-100 dark:bg-neutral-800 text-neutral-500 hover:text-neutral-900 flex items-center justify-center font-bold text-lg">
            ✕
          </button>
        </div>

        <!-- Abas -->
        <div class="flex border-b border-neutral-200 dark:border-neutral-800 bg-neutral-50 dark:bg-neutral-800/40">
          <button type="button" id="tab-pix" class="flex-1 py-3 text-xs font-bold text-center border-b-2 transition-all ${
            abaAtiva === 'pix'
              ? 'border-emerald-600 text-emerald-600 dark:text-emerald-400 bg-white dark:bg-neutral-900'
              : 'border-transparent text-neutral-500 hover:text-neutral-800'
          }">
            ⚡ 1. Adquirir via Pix (R$ 29,90)
          </button>
          <button type="button" id="tab-chave" class="flex-1 py-3 text-xs font-bold text-center border-b-2 transition-all ${
            abaAtiva === 'chave'
              ? 'border-emerald-600 text-emerald-600 dark:text-emerald-400 bg-white dark:bg-neutral-900'
              : 'border-transparent text-neutral-500 hover:text-neutral-800'
          }">
            🔑 2. Ativar com Chave
          </button>
        </div>

        <!-- Conteúdo das Abas -->
        <div class="p-6">
          ${
            abaAtiva === 'pix'
              ? `
            <div class="space-y-4">
              <!-- Benefícios -->
              <div class="grid grid-cols-2 gap-2 text-[11px] font-semibold text-neutral-700 dark:text-neutral-300 bg-emerald-50 dark:bg-emerald-950/30 p-3 rounded-2xl border border-emerald-100 dark:border-emerald-900/40">
                <div class="flex items-center gap-1.5 text-emerald-800 dark:text-emerald-300">✓ Orçamentos Ilimitados</div>
                <div class="flex items-center gap-1.5 text-emerald-800 dark:text-emerald-300">✓ PDF Sem Marca d'Água</div>
                <div class="flex items-center gap-1.5 text-emerald-800 dark:text-emerald-300">✓ Exportar Excel/CSV</div>
                <div class="flex items-center gap-1.5 text-emerald-800 dark:text-emerald-300">✓ Suporte Prioritário</div>
              </div>

              <!-- Cartão do Pix -->
              <div class="bg-neutral-50 dark:bg-neutral-800/60 rounded-2xl p-4 border border-neutral-200 dark:border-neutral-700 text-center space-y-3">
                <div class="flex justify-center">
                  <div class="qr-plate p-2.5 bg-white rounded-2xl border border-neutral-200 shadow-sm inline-block">
                    ${qrCodeSvg}
                  </div>
                </div>

                <div class="space-y-1">
                  <div class="text-xs text-neutral-500">Valor do Plano Anual (12 meses):</div>
                  <div class="text-2xl font-black text-emerald-600 dark:text-emerald-400">R$ 29,90 <span class="text-xs font-semibold text-neutral-400">(R$ 2,49/mês)</span></div>
                  <div class="text-[11px] text-neutral-400">Pagamento único sem renovação automática no cartão</div>
                </div>

                <div class="pt-2 flex flex-wrap gap-2 justify-center">
                  <button type="button" id="btn-copiar-brcode" class="btn-touch btn-primary px-4 py-2.5 text-xs font-bold shadow-md flex items-center gap-1.5">
                    <span>📋 Copiar Pix Copia e Cola</span>
                  </button>
                  <button type="button" id="btn-copiar-chave-pix" class="btn-touch btn-secondary px-3 py-2.5 text-xs font-bold flex items-center gap-1.5">
                    <span>🔑 Copiar Chave Pix</span>
                  </button>
                </div>
              </div>

              <!-- Próximo Passo -->
              <div class="p-3.5 rounded-2xl bg-amber-50 dark:bg-amber-950/30 border border-amber-200 dark:border-amber-800 text-xs space-y-2">
                <p class="text-amber-900 dark:text-amber-200 font-bold flex items-center gap-1.5">
                  <span>💬 Como receber sua chave imediatamente:</span>
                </p>
                <p class="text-amber-800 dark:text-amber-300 text-[11px] leading-relaxed">
                  Após pagar os R$ 29,90 no seu banco (Chave: <strong>codjeremias@gmail.com</strong>), envie o comprovante por e-mail ou WhatsApp para receber sua Chave Pro:
                </p>
                <div class="grid grid-cols-1 sm:grid-cols-2 gap-2 pt-1">
                  <a href="mailto:codjeremias@gmail.com?subject=${encodeURIComponent(
                    'Comprovante Pix - Passaporte ZapOrca Pro Anual'
                  )}&body=${encodeURIComponent(
                    'Olá Jeremias! Segue em anexo meu comprovante do Pix de R$ 29,90 para ativar o ZapOrca Pro Anual.\n\nNome ou Empresa: \nTelefone/WhatsApp: '
                  )}" class="btn-touch w-full py-2.5 rounded-xl bg-neutral-900 dark:bg-neutral-800 hover:bg-black text-white font-bold text-xs flex items-center justify-center gap-1.5 shadow-sm text-center">
                    <span>✉️ Enviar no E-mail</span>
                  </a>
                  <a href="https://wa.me/5511999999999?text=${encodeURIComponent(
                    'Olá! Acabei de fazer o Pix de R$ 29,90 (para codjeremias@gmail.com) para ativar o ZapOrca Pro Anual. Segue meu comprovante:'
                  )}" target="_blank" rel="noopener noreferrer" class="btn-touch w-full py-2.5 rounded-xl bg-emerald-600 hover:bg-emerald-700 text-white font-bold text-xs flex items-center justify-center gap-1.5 shadow-sm text-center">
                    <span>📲 Enviar no WhatsApp</span>
                  </a>
                </div>
              </div>
            </div>
          `
              : `
            <form id="form-ativar-chave" class="space-y-4">
              <div>
                <label class="block text-xs font-bold text-neutral-700 dark:text-neutral-300 uppercase tracking-wider mb-1.5">
                  Cole sua Chave de Licença Pro *
                </label>
                <textarea id="input-chave-pro" rows="4" required class="input-touch font-mono text-xs w-full" placeholder="ZAPORCA-PRO.eyJzdWIi..."></textarea>
                <span class="text-[11px] text-neutral-400 mt-1 block">A chave contém duas partes criptografadas com assinatura ECDSA P-256.</span>
              </div>

              <div id="pro-erro-msg" class="text-xs text-red-600 dark:text-red-400 font-semibold hidden p-2.5 rounded-xl bg-red-50 dark:bg-red-950/40 border border-red-200 dark:border-red-900"></div>

              <button type="submit" id="btn-submit-ativar" class="btn-touch btn-primary w-full py-3.5 text-xs font-bold shadow-md flex items-center justify-center gap-2">
                <span>✨ Validar e Ativar Passaporte Pro</span>
              </button>

              <div class="text-center pt-2">
                <button type="button" id="link-ir-pix" class="text-xs text-emerald-600 dark:text-emerald-400 hover:underline font-semibold">
                  Ainda não comprou? Pague R$ 29,90 via Pix na aba anterior
                </button>
              </div>
            </form>
          `
          }
        </div>
      </div>
    `;

    // Eventos
    modal.querySelector('#btn-fechar-pro')?.addEventListener('click', () => modal.remove());

    modal.querySelector('#tab-pix')?.addEventListener('click', () => {
      abaAtiva = 'pix';
      renderConteudo();
    });

    modal.querySelector('#tab-chave')?.addEventListener('click', () => {
      abaAtiva = 'chave';
      renderConteudo();
    });

    modal.querySelector('#link-ir-pix')?.addEventListener('click', () => {
      abaAtiva = 'pix';
      renderConteudo();
    });

    modal.querySelector('#btn-copiar-brcode')?.addEventListener('click', async () => {
      try {
        await navigator.clipboard.writeText(pixResult.brCode);
        const btn = modal.querySelector('#btn-copiar-brcode') as HTMLButtonElement;
        const textoOriginal = btn.innerHTML;
        btn.innerHTML = '<span>✓ Copiado!</span>';
        setTimeout(() => (btn.innerHTML = textoOriginal), 2000);
      } catch {
        alert('Código Pix Copia e Cola:\n\n' + pixResult.brCode);
      }
    });

    modal.querySelector('#btn-copiar-chave-pix')?.addEventListener('click', async () => {
      try {
        await navigator.clipboard.writeText(CONFIG_PIX_ZAPORCA_PRO.chavePix);
        const btn = modal.querySelector('#btn-copiar-chave-pix') as HTMLButtonElement;
        const textoOriginal = btn.innerHTML;
        btn.innerHTML = '<span>✓ Chave Copiada!</span>';
        setTimeout(() => (btn.innerHTML = textoOriginal), 2000);
      } catch {
        alert('Chave Pix: ' + CONFIG_PIX_ZAPORCA_PRO.chavePix);
      }
    });

    const form = modal.querySelector('#form-ativar-chave') as HTMLFormElement | null;
    form?.addEventListener('submit', async (e) => {
      e.preventDefault();
      const input = modal.querySelector('#input-chave-pro') as HTMLTextAreaElement;
      const erroBox = modal.querySelector('#pro-erro-msg') as HTMLElement;
      const btnSubmit = modal.querySelector('#btn-submit-ativar') as HTMLButtonElement;

      erroBox.classList.add('hidden');
      btnSubmit.disabled = true;
      btnSubmit.innerHTML = '<span>Validando assinatura digital...</span>';

      try {
        const resultado = await ativarLicencaPro(input.value.trim());
        if (resultado.ok && resultado.payload) {
          options.onAtivado?.();
          renderConteudo();
        } else {
          erroBox.textContent = resultado.erro || 'Falha na validação da chave de licença.';
          erroBox.classList.remove('hidden');
          btnSubmit.disabled = false;
          btnSubmit.innerHTML = '<span>✨ Validar e Ativar Passaporte Pro</span>';
        }
      } catch (err) {
        erroBox.textContent = `Erro inesperado: ${err instanceof Error ? err.message : String(err)}`;
        erroBox.classList.remove('hidden');
        btnSubmit.disabled = false;
        btnSubmit.innerHTML = '<span>✨ Validar e Ativar Passaporte Pro</span>';
      }
    });
  }

  modal.addEventListener('click', (e) => {
    if (e.target === modal) modal.remove();
  });

  renderConteudo();
  document.body.appendChild(modal);
}
